import { render, staticRenderFns } from "./field-search-text.vue?vue&type=template&id=2815611d&scoped=true&"
import script from "./field-search-text.vue?vue&type=script&lang=js&"
export * from "./field-search-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2815611d",
  null
  
)

export default component.exports